export const MAP_TYPES = {
  LEGACY: 'legacy-map',
  ENHANCED: 'enhanced-map',
};
